import { render, staticRenderFns } from "./FlowInvoiceInformationView.vue?vue&type=template&id=37179854&scoped=true&"
import script from "./FlowInvoiceInformationView.vue?vue&type=script&lang=ts&"
export * from "./FlowInvoiceInformationView.vue?vue&type=script&lang=ts&"
import style0 from "./FlowInvoiceInformationView.vue?vue&type=style&index=0&id=37179854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37179854",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
